import MetricBase from "models/metrics/MetricBase";
import ConversionGroup from "models/groups/ConversionGroup";
import PercentUnit from "models/metrics/unit/PercentUnit";
import i18n from "i18next";

class MetricConversion extends MetricBase {
    constructor() {
        super({
            field: "metric_conversion_rate",
            defaultVisibility: true,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.conversion.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.conversion.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.conversion.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricConversion;
